// @ts-nocheck
import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import history from '@/asset/js/history';
import Loading from '@/component/loading';

// const Home = lazy(() => import('@/page/home'));
const Main = lazy(() => import('@/page/main'));
// const PrivacyPolicy = lazy(() => import('@/page/privacyPolicy'));
const PrivacyPolicyBobo = lazy(() => import('@/page/privacyPolicyBobo'));
// const TermsAndConditions = lazy(() => import('@/page/terms&Conditions'));
const TermsAndConditionsBobo = lazy(() => import('@/page/terms&ConditionsBobo'));
const Concat = lazy(() => import('@/page/concat'));
const authcheck = Com => {
  return (
    // <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <Com history={history} />
    </Suspense>
    // </ErrorBoundary>
  );
};

const suspense = (Com, params) => {
  return (
    <Suspense fallback={<Loading />}>
      <Com {...params} />
    </Suspense>
  );
};

const routerList = [
  {
    path: '/',
    element: <Navigate to='/main' />
  },
  {
    path: '/main',
    element: suspense(Main)
  },
  {
    path: '/concat',
    element: suspense(Concat),
  },
  {
    path: '/privPolicy',
    element: suspense(PrivacyPolicyBobo)
  },
  {
    path: '/termService',
    element: suspense(TermsAndConditionsBobo)
  },
];

export default routerList;
